/*
Sounds.js plays all sounds and handles mute functionality
*/
import Phaser, {
    Display,
    Sound
} from 'phaser'

let background;
let click;
let _this;
let soundEffect;
let pop;


export default class Sounds extends Phaser.Scene {
    constructor() {
        super('sounds')
        _this = this;
    }
    init() {
        this.registry.set('isSound', true);
        click = this.sound;

    }

    create() {
        soundEffect = this.sound;

        this.sound.setDetune(50);

        click = this.sound.add('click');
        pop = this.sound.add('pop');

    }

    stopBackgroundSound() {
        background.mute = true;
    }
    playBackgroundSound() {
        background.mute = false;
    }

    setBackgroundSound(id, vol = 0.5, loop = true) {

        if (background) background.stop();
        background = _this.sound.add(id, {
            volume: vol,
            loop: loop
        });
        background.play();

    }

    //Can alter this test now that we have allowed for 2 instances
    blipBloop(id, vol = 1) {
        soundEffect = _this.sound.add(id, {
            volume: vol

        });

        soundEffect.play();


    }

    playClick() {

        click.play();

    }
    playPop() {
        pop.play();
    }

    muteSound() {

        let val = this.registry.get('isSound');

        this.registry.set('isSound', !val);

        this.sound.mute = val;

        if (!this.sound.mute) {
            //background.resume();
            this.sound.resumeAll();
        }

        this.playClick();
        this.scene.get('menu').showSound(val);
    }

}